module.exports = __webpack_public_path__ + "static/media/passwordgenerator.0d55b663.png";